import '../styles/index.scss';

async function loader() {
  const { default: loaderModule } = await import('./modules/loader');
  return loaderModule();
}

async function loadModules() {
  const { default: header } = await import('./modules/header');
  header();

  const { default: borderReveal } = await import('./modules/borderReveal');
  borderReveal();

  const { default: buttonReveal } = await import('./modules/buttonReveal');
  buttonReveal();

  const { default: imageAnimations } = await import('./modules/imageAnimations');
  imageAnimations();

  const { default: highlight } = await import('./modules/highlight');
  highlight();

  const { default: positionImages } = await import('./modules/positionImages');
  positionImages();

  const { default: panelPinning } = await import('./modules/panelPinning');
  panelPinning();

  const { default: readmore } = await import('./modules/readmore');
  readmore();

  const { default: scaleReveal } = await import('./modules/scaleReveal');
  scaleReveal();

  const { default: splitReveal } = await import('./modules/splitReveal');
  splitReveal();

  const { default: staggerReveal } = await import('./modules/staggerReveal');
  staggerReveal();
}

document.addEventListener('DOMContentLoaded', async () => {
  await loader();
  setTimeout(async () => {
    await loadModules();
  }, 500);
});
